import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { localePath } from '../config/region';
import { t } from '../i18n';
import ParticleBackground from './ParticleBackground';
import SeoHead from './SeoHead';
import './LegalPage.css';

const LegalPage = ({ title, description, jsonLd, children }) => {
  return (
    <div className="lp-wrap">
      <SeoHead title={title} description={description} jsonLd={jsonLd} type="article" />
      <ParticleBackground />
      <div className="lp-app">
        <div className="lp-header">
          <a href={localePath('/')} className="lp-back">
            <ChevronLeft size={14} /> {t('На главную')}
          </a>
          <h1 className="lp-title">{title}</h1>
        </div>
        <div className="lp-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
